import { ACCREDITATION_ROLES } from 'libs/utils/src/lib/player-portals/constants/pp-accreditation-roles';

const roleMap = Object.fromEntries(
  Object.values(ACCREDITATION_ROLES).map(role => [role.value, role.label]),
);

const valueToLabelMap: Record<string, Record<any, string>> = {
  role: roleMap,
  subCategory: roleMap,
  addedToChampionshipContacts: {
    false: 'No',
    true: 'Yes',
  },
};

export { valueToLabelMap };
